import React, { useContext, useEffect, useState } from 'react'
import SearchBarNew from '../../Components/Custom/UI/SearchBarNew'
import ProfessionalCard from '../../Components/Custom/UI/ProfessionalCard'
import '../../CSS/UI Components/ProfessionalUnderCategory.css'
import { useMediaQuery } from "react-responsive"
import { NavLink, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import AllServicesIcon from '../../Assets/AllServices.png'
import filtersIcon from '../../Assets/filterIcon.png'
import ratingsIcon from '../../Assets/ratingsIcon.png'
import discountIcon from '../../Assets/discountIcon.png'
import filterIcon_white from '../../Assets/filterIcon_white.png'
import ratingsIcon_white from '../../Assets/ratingsIcon_white.png'
import discountIcon_white from '../../Assets/discountIcon_white.png'
import DropdownIcon from '../../Assets/dropdown_black.png'
import CloseIcon from '../../Assets/icons-closeModal.png'
import dropDown_filter from '../../Assets/dropdown_white.png'
import { catImages, subcatImages } from '../../Components/CatIcons';
import subcat_img from '../../Assets/subcat_img.png'
import FilterArrowUp from '../../Assets/filters_arrow_up.png'
import FilterArrowDown from '../../Assets/filters_arrow_down.png'
import crossIcon from '../../Assets/crossIcon.png'
import DatePicker from "react-date-picker";
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import TimePicker from 'react-time-picker';
import moment from 'moment'
import momenttz from "moment-timezone"
import { globalState } from '../../GlobalState/globalState'
import calendarIcon from '../../Assets/calendarIcon.png'
import timeIcon from '../../Assets/timeIcon.png'
import StarIconGreen from '../../Assets/material-symbols-star-rounded.png'
import 'react-time-picker/dist/TimePicker.css';
import 'react-clock/dist/Clock.css';
import { Range } from 'react-range';
import numeral from 'numeral';
import curr from 'currency.js';
import { ToastContainer, toast } from 'react-toastify';
import customFetchData from '../../Components/Custom/customFetchData';
import { catColors } from '../../Components/Custom/UI/Colors'
import { ClipLoader } from 'react-spinners';
import {Helmet} from "react-helmet";
import useDebounce from '../../Components/Custom/Hooks/useDebounce'
import { toCategorySlug, toSubCategorySlug, toProNameSlug, slugToCatName, slugToSubCatName } from '../../Navigation/NavigationSlug';
// import "react-datepicker/dist/react-datepicker-cssmodules.css";
// import '../../../../node_modules/react-datepicker/dist/react-datepicker.css';
import { Container, Row, Col, Card, CardBody, CarouselItem, Carousel, Navbar, CarouselIndicators, Modal, ModalFooter, ModalHeader, ModalBody, Collapse, FormGroup } from 'reactstrap'
import { clearAddress, clearServices, storeAddress, storeDateAndTime, storeServices } from '../../GlobalState/globalStateActions'
import FetchCurrentLocation from '../../Components/Custom/FetchCurrentLocation'
import NewProfessionalCard from '../../Components/Custom/UI/NewProfessionalCard'
import BookAserviceWithUs from '../../Components/Custom/UI/BookAserviceWithUs'
const DeepClone = require("rfdc/default")
export default function ProfessionalUnderCategory() {
    const [state, dispatch] = useContext(globalState)
    const paramsLocation = useLocation()
    const navigate = useNavigate()
    const [searchTextOffer, setSearchTextOffer] = useState("")
    const [nearByPros, setNearByPros] = useState([])
    const [categories, setCategories] = useState([])
    const [subCategories, setsubCategories] = useState([])
    const [activeIndex, setActiveIndex] = useState(0);
    const [subcategories, setSubcategories] = useState([])
    const [filtersModal, setFiltersModal] = useState(false)
    const [sortRatings, setSortRatings] = useState(false)
    const [sortDiscount, setSortDiscount] = useState(false)
    const [dateCollapsed, setDateCollapsed] = useState(true)
    const [timeCollapsed, setTimeCollapsed] = useState(true)
    const [priceCollapsed, setPriceCollapsed] = useState(true)
    const [distanceCollapsed, setDistanceCollapsed] = useState(true)
    const [distanceMin, setDistanceMin] = useState(state.distanceMin)
    const [distanceMax, setDistanceMax] = useState(state.distanceMax)
    const [ratingsMin, setRatingsMin] = useState(0)
    const [ratingsMax, setRatingsMax] = useState(5)
    const [priceMin, setPriceMin] = useState(0)
    const [priceMax, setPriceMax] = useState(state.address.country === 'India' ? 15000 : 5000)
    const [male, setMale] = useState(false)
    const [both, setBoth] = useState(false)
    const [checked, setChecked] = useState([])
    const [selectedCatPrid, setSelectedCatPrid] = useState(0)
    const [onClickReset, setOnClickReset] = useState(false)
    const [country, setCountry] = useState('IN')
    const [isDateTimePickerVisible, setIsDateTimePickerVisible] = useState(false)
    const [isDateTimePickerVisible1, setIsDateTimePickerVisible1] = useState(false)
    const [isDateTimePickerVisible2, setIsDateTimePickerVisible2] = useState(false)
    const [isDateTimePickerVisible3, setIsDateTimePickerVisible3] = useState(false)
    const [fromDateTime, setFromDateTime] = useState('')
    const [toDateTime, setToDateTime] = useState('')
    const [mindate, setMindate] = useState('')
    const [selectedBTimes, setSelectedBTimes] = useState({ fromTime: moment().set({ 'hour': 0, 'minute': 0 }), toTime: moment().set({ 'hour': 23, 'minute': 59 }) })
    const [fromHours, setFromHours] = useState('')
    const [toHours, setToHours] = useState('')
    const [subLoading, setSubLoading] = useState(true)
    const [proLoading, setProLoading] = useState(true)
    const [catPrid, setCatPrid] = useState(null)
    const [filteredSubCats, setFilteredSubCats] = useState([])
    const [subCatPrid, setSubCatPrid] = useState(null)
    const [subcatCheck, setSubcatCheck] = useState({})
    const [searchDropdownArray, setSearchDropdownArray] = useState([])
    const [didClearSearch, setDidClearSearch] = useState(false)
    const [showSearchDropDown, setShowSearchDropDown] = useState(false)
    const [searchClickedValue, setSearchClickedValue] = useState("")
    const [clickOnOfferSearch, setClickOnOfferSearch] = useState(false)
    const [merchantTimeZone, setMerchantTimeZone] = useState(state.country.timezone)
    const [filteredNearByPros, setFilteredNearByPros] = useState([])
    const [applyButtonLoading, setApplyButtonLoading] = useState(false)
    const [calFilteredOffers, setCalFilteredOffers] = useState('')
    const [onApplyClick, setOnApplyClick] = useState(false)
    const [onApplyClick2, setOnApplyClick2] = useState(false)
    const [mpidArr, setMpidArr] = useState([])
    // const [mpidArr, setMpidArr] = useState(['1473, 1640, 1713,1714,1715,1716,1718,1720,1729,1730,1734,1750,1759,1760,1766,1768,1770,771,1772,1773,1777, 788,1790,1797,1851,1885,1905,1906,1909,1912,1911,1921,1923,1927,1930,1934,1941,1944,1945,1952,2033,2035,2036,2052,2087,2088,2097,2099, 2100,2104,2105,2110,2114,2121,2118,22102,22159,22161,22171,22181,21731,21732,21745,21747, 21751,21753,21754, 21758,21762,21765,21764,21774,21795,21798,21896,21898,21907,21908,21928,21929,21938,21940,21942,21943,21955,21961,21963, 22022,22021, 2028,2030,2055,2086,2103,2106,2107,1722,1725,1726,1727,1728,1740, 1763,1767,1776, 1628,1789,1796,2077,2083,2084,1783,1939,2119'])
    const [prevFilters, setPrevFilters] = useState({})
    const [bannerImage, setBannerImage] = useState('')
    const [searchSamePage, setSearchSamePage] = useState(false)
    const [cityNotYet, setCityNotYet] = useState(false)
    const [categoryName, setCategoryName] = useState('')
    const [loadingCat,setLoadingCat]=useState(true)
    const [searchParams, setSearchParams] = useSearchParams()
    const useMobileAndBelowMediaQuery = () => useMediaQuery({ query: "(max-width: 760px)" })
    const useTabletMediaQuery = () => useMediaQuery({ minWidth: 768, maxWidth: 991 })
    const isMobileView = useMobileAndBelowMediaQuery()
    const isTabView = useTabletMediaQuery()
    const [titleOptions,setTitleOptions] = useState([])
    const [subCatName, setSubCatName] = useState('')
    const [isLoading, setIsLoading] = useState(false);
    // const debouncedSearchText = useDebounce(searchTextOffer, 500);
    const [offerData, setOfferData] = useState([])
    const [catMpidArr, setCatMpidArr] = useState([])
    const [serviceSearched, setServiceSearched] = useState(false)
    const [reviewCount, setReviewCount] = useState(10)
    const [catRating, setCatRating] = useState(0)
    const [displayCount, setDisplayCount] = useState(0)
    const [catVideoLink, setCatVideoLink] = useState('')
    const [randomRating, setRandomRating] = useState(4.5)
    const [searchModalOpen, setSearchModalOpen] = useState(false)
    const [recentResultsNotFound, setRecentResultsNotFound] = useState(false)
    const [serSearchProsLoading, setSerSearchProsLoading] = useState(false)
    const debouncedSearchText = useDebounce(searchTextOffer, 500);
    const [serviceSearchPros, setServiceSearchPros] = useState([])
    const [searchRequested, setSearchRequested] = useState(false)
    const [hiderecentSearches, setHiderecentSearches] = useState(false)
    const [noResSearchCard, setNoResSearchCard] = useState("")
    const [serviceSearchedName, setServiceSearchedName] = useState('')
    let searchUrl = paramsLocation.search
    let merchantTimezoneL = state.country.timezone

    let title
    let MerchantItems = [
        {
            key: 1,
            src: {
                // web:NewImageMer,
                // mobile:NewImageMerMobile
            },
            altText: (
                <div>
                    {/* <div style={{position:'absolute'}}>
                  <NewNavbarWebsite/>
              </div> */}
                    <div style={{ top: '45%', left: '10%', right: '15%', position: 'absolute', display: 'flex', flexDirection: 'column', zIndex: 10 }}>
                        {/* <div className="textStyle_sv2"> */}
                        <text className='serviceText_sv2'>Are you looking for services ?</text>
                        <text className='serviceTextDesc_sv2'>Explore top deals and offers exclusively for you</text>
                        {/* </div> */}
                    </div>
                </div>
            ),
        },
    ]
    let MerchantSlides = MerchantItems.map((item) => {
        return (

            <CarouselItem
                // onExiting={this.onExiting}
                // onExited={this.onExited}
                key={item.key}
            >
                <div className="CarousalContainer_Sv3_puc">
                    {item.altText}

                    {/* <img className='imgStylesv2_puc' src={bannerImage} /> */}
                    {/* <img src={'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1666875231964-lg.jpg'} className='Carousal_policy_mobile'/> */}
                </div>
            </CarouselItem>

        );
    });
    let header = {
        flexDirection: 'row',
        display: 'flex',
        justifyContent: 'space-between',
        // marginHorizontal: 30,
        marginTop: 25,
    }
    let dateStyle = {
        fontFamily: 'Inter',
        fontSize: 16,
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        textAlign: 'left',
        color: '#747474'
    }
    let dateViewStyle = {
        borderRadius: 5,
        backgroundColor: "#ffffff",
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: "#e1e1e1",
        marginHorizontal: 30,
        marginTop: 20,
        padding: 12,
    }
    let timeViewStyle = {
        borderRadius: 5,
        backgroundColor: "#ffffff",
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: "#e1e1e1",
        marginHorizontal: 30,
        marginTop: 20,
        padding: 12,
    }
    let priceBox = {
        width: 75,
        // height: 28,
        borderRadius: 5,
        backgroundColor: "#ffffff",
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: "#e1e1e1",
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 0
    }
    let priceTextStyle = {
        fontFamily: "Inter",
        fontSize: 12,
        fontWeight: "300",
        fontStyle: "normal",
        letterSpacing: 0,
        textAlign: "left",
        color: "#000000"

    }
    let resetStyle = {
        width: '47%',
        height: 60,
        // padding:10,
        borderRadius: 10,
        backgroundColor: "#ffffff",
        borderStyle: "solid",
        borderWidth: 1.5,
        borderColor: 'rgb(140,82,255)',
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
        cursor: 'pointer'
    }
    let updateStyle = {
        width: '47%',
        height: 60,
        borderRadius: 10,
        backgroundColor: "#ffffff",
        borderStyle: "solid",
        borderWidth: 1.5,
        borderColor: 'rgb(140,82,255)',
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
        backgroundColor: 'rgb(140,82,255)',
        cursor: 'pointer'

    }
    let ResetTextStyle = {
        // height: 19,
        fontFamily: "Inter",
        fontSize: 16,
        fontWeight: "bold",
        fontStyle: "normal",
        letterSpacing: 0,
        // textAlign: "center",
        color: 'rgb(140,82,255)'
    }
    let updateTextStyle = {
        // height: 19,
        fontFamily: "Inter",
        fontSize: 16,
        fontWeight: "bold",
        fontStyle: "normal",
        letterSpacing: 0,
        // textAlign: "center",
        color: '#fff'
    }
    const FetchLocation = async (searchParams) => {
        let addressDetails = await FetchCurrentLocation(state, dispatch)
        // console.log('addressDetails in fetch location',searchParams, addressDetails,paramsLocation.state)
        setCategoryName(searchParams.category)
        let city_data = {
            curr_city: addressDetails.city ? addressDetails.city : 'Hyderabad',
            // curr_city: 'Hyderabad',
            curr_lat: addressDetails.curr_location_latitude ? addressDetails.curr_location_latitude : 17.4216,
            // curr_lat: 17.4216,
            curr_long: addressDetails.curr_location_longitude ? addressDetails.curr_location_longitude : 78.3572,
            // curr_long: 78.3572,
            stateOrProvince: addressDetails.stateOrProvince ? addressDetails.stateOrProvince : 'Telangana',
            // stateOrProvince: 'Telangana',
            selectedServiceTab:"in_store"
        }
        if (state.user.id && state.token) {
            city_data.consumerId = state.user.id
        }
        let { fetchedData } = await customFetchData('POST', city_data, '/website/fetchCurrentLocationCatsAndPros/LandingPage', state, dispatch)
        console.log('fetchedData in fetch location', fetchedData)
        if (fetchedData.getOff) {
            setCategories(fetchedData.catsFinal)
            // setsubCategories(fetchedData.subcatsFinal)
            setMpidArr(fetchedData.mpidArr)
            setNearByPros(fetchedData.offers)
            let mpidArr = [];
            mpidArr = fetchedData.mpidArr
            if (fetchedData.mpidArr.length !== 0) {
                
            }
            console.log('fetchedData.mpidArr in fetch location2')
            setMpidArr(fetchedData.mpidArr)
            // if (fetchedData.offers) {
            //     if (searchParams.category == 'Beauty') {
            //         setBannerImage('https://qf-test-media.s3.us-west-2.amazonaws.com/Images_New/1684392482507-lg.png')
            //     }
            //     else if (searchParams.category == 'HairCare') {
            //         setBannerImage('https://qf-test-media.s3.us-west-2.amazonaws.com/Images_New/1684392552994-lg.png')
            //     }
            //     else if (searchParams.category == 'NailCare') {
            //         setBannerImage('https://qf-test-media.s3.us-west-2.amazonaws.com/Images_New/1684392573064-lg.png')
            //     }
            //     else if (searchParams.category == 'AutoCare') {
            //         setBannerImage('https://qf-test-media.s3.us-west-2.amazonaws.com/Images_New/1684392470139-lg.png')
            //     }
            //     else {
            //         setBannerImage('https://qf-test-media.s3.us-west-2.amazonaws.com/Images_New/1684392552994-lg.png')
            //     }
            // }
            console.log('fetchedData in fetch location3')
            setSearchTextOffer('')
            setShowSearchDropDown(false)
            let categories = DeepClone(fetchedData.catsFinal ? fetchedData.catsFinal : [])
            setCategories(categories)
            console.log('categories in fetch location', Number(searchParams.catId ? searchParams.catId : 0),searchParams.category)
            setCatPrid(Number(searchParams.catId ? searchParams.catId : 0))
            setCategoryName(searchParams.category)
            setSelectedCatPrid(Number(searchParams.catId ? searchParams.catId : 0))
            console.log('before fetchData func',searchParams.categoryId, searchParams.category, fetchedData.mpidArr,fetchedData.offers)
            fetchData(searchParams.categoryId, searchParams.category, fetchedData.mpidArr,fetchedData.offers)
        }
        else {
            if (fetchedData.cityNotYet) {
                setCityNotYet(true)
            }
            else {
                toast.error("Something went wrong. Please try later.", { position: toast.POSITION.BOTTOM_CENTER });
            }
            setCategories([])
            setsubCategories([])
            setNearByPros([])
            setFilteredNearByPros([])
            // storeServices([],[],[],dispatch)
            //   dispatch({type:'SET_SERVICES',services:[]})
            //   dispatch({type:'SET_CATEGORIES',categories:[]})
            //   dispatch({type:'SET_SUBCATEGORIES',subcategories:[]})
            //   dispatch({type:'SET_SERVICE_REFRESH_COUNTER',servicesRefreshCounter:servicesRefreshCounter+1})
        }
        setLoadingCat(false)
    }
    useEffect(() => {
        if (paramsLocation.state) {
            console.log('paramsLocation.state', paramsLocation.state)
            if (paramsLocation.state && paramsLocation.state.nearByPros.length !== 0) {
                let timezoneLocal = 'Asia/Kolkata'
                setMerchantTimeZone(timezoneLocal)
                merchantTimezoneL = timezoneLocal
                // setMerchantTimeZone(paramsLocation.state.nearByPros[0][0].SERVICE_TIMEZONE)
                // merchantTimezoneL = paramsLocation.state.nearByPros[0][0].SERVICE_TIMEZONE
                setMindate(moment().tz(merchantTimezoneL))
                setFromDateTime(moment().tz(merchantTimezoneL).set({ 'hour': 0, 'minute': 0 }))
                setToDateTime(moment().tz(merchantTimezoneL).set({ 'hour': 23, 'minute': 59 }).add(14, "days"))
            }
            console.log('timezone', merchantTimezoneL)
            if (paramsLocation.state) {
                if (paramsLocation.state.catItem.category_name == 'Beauty') {
                    setBannerImage('https://qf-test-media.s3.us-west-2.amazonaws.com/Images_New/1684392482507-lg.png')
                }
                else if (paramsLocation.state.catItem.category_name == 'Hair Care') {
                    setBannerImage('https://qf-test-media.s3.us-west-2.amazonaws.com/Images_New/1684392552994-lg.png')
                }
                else if (paramsLocation.state.catItem.category_name == 'Nail Care') {
                    setBannerImage('https://qf-test-media.s3.us-west-2.amazonaws.com/Images_New/1684392573064-lg.png')
                }
                else if (paramsLocation.state.catItem.category_name == 'Auto Care') {
                    setBannerImage('https://qf-test-media.s3.us-west-2.amazonaws.com/Images_New/1684392470139-lg.png')
                }
                else {
                    setBannerImage('https://qf-test-media.s3.us-west-2.amazonaws.com/Images_New/1684392552994-lg.png')
                }
            }
            // let fromDateTime = moment().tz(merchantTimezoneL).set({ 'hour': 0, 'minute': 0 })
            // let toDateTime = moment().tz(merchantTimezoneL).set({ 'hour': 23, 'minute': 59 }).add(14, "days")
            // storeDateAndTime(fromDateTime, toDateTime, dispatch)
            setSearchTextOffer('')
            setShowSearchDropDown(false)
            let categories = DeepClone(paramsLocation.state ? paramsLocation.state.categories : [])
            console.log('categories in useEffect', categories)
            setCategories(categories)
            setCatPrid(paramsLocation.state ? (paramsLocation.state.catPrid ? paramsLocation.state.catPrid : null) : null)
            fetchData(paramsLocation.state.catPrid, paramsLocation.state.catItem.category_name, paramsLocation.state.mpidArr,paramsLocation.state.nearByPros)
        }
        else {
            let regex = /[?&]([^=#]+)=([^&#]*)/g, searchParams = {}, match
            while ((match = regex.exec(searchUrl))) {
                searchParams[match[1]] = match[2]
            }
            setCategoryName(searchParams.category)
            setCatPrid(Number(searchParams.catId ? searchParams.catId : 0))           
            FetchLocation(searchParams)
            
        }
        
    }, [])
    useEffect(() => {
    if (debouncedSearchText && String(debouncedSearchText).trim().length > 3) {
      performSearch(debouncedSearchText);
    } else {

    }
  }, [debouncedSearchText]);
    const performSearch = async (query) => {
        try {
            console.log('in perform search', query)
            const body = {
            query: query,
            mpidArr: mpidArr,
            catPrid: catPrid,
        }
        let userDataforRate = await customFetchData('POST', body, '/website/homepage/Cat_Ser_Pro/Search', state, dispatch)
        console.log('userDataforRate in searchBoxOfferHandler', userDataforRate,body)
        let filteredNearByProsArr = DeepClone(nearByPros), matchesArr = [], filteredOffers1 = DeepClone(userDataforRate?.fetchedData?.serviceData || [])
        query = query ? query.trim() : query

        if (query.length > 2) {
            setShowSearchDropDown(true)
            console.log("filtered",filteredOffers1)
            filteredNearByProsArr.map((insideItem) => {
                // console.log('item123',insideItem)
                if (insideItem && insideItem.MERCHANT_NAME && insideItem.MERCHANT_NAME.search(new RegExp(query, 'i')) !== -1) {
                    insideItem.type = 'Professional'
                    // console.log("matchesArr in pro filter",insideItem);
                    matchesArr.push(insideItem)
                }
            })

            //    return console.log("matchesArr outside", filteredOffers1);

            filteredOffers1.map((insideItem) => {

                if (insideItem && insideItem.SERVICE_NAME && insideItem.SERVICE_NAME.search(new RegExp(query, 'i')) !== -1) {
                    insideItem.type = 'Service'
                    // console.log("matchesArr in service filter",insideItem);
                    matchesArr.push(insideItem)
                }
            })
            console.log("matchesArr outside",matchesArr);
            let proArray, servicesArray;
            proArray = matchesArr.filter(item => {
                return item.type == "Professional"
            })
            servicesArray = matchesArr.filter(item => {
                return item.type == 'Service'
            })
            // console.log('all',proArray,catArray,servicesArray)
            let finalArray = [];
            if (proArray.length !== 0) {
                // console.log('pro dataaaa',proArray)
                proArray.map(item => {
                    finalArray.push(item);
                })
            }

            if (servicesArray.length !== 0) {
                servicesArray = servicesArray.filter((v, i, a) => a.findIndex(t => ((t.SERVICE_NAME === v.SERVICE_NAME))) === i)
                servicesArray.map(item => {
                    finalArray.push(item);
                })
            }
            console.log('final array',finalArray)
            if (finalArray.length !== 0) {
                setSearchDropdownArray(finalArray)
            }
        }
        else {
            setShowSearchDropDown(false)
            setClickOnOfferSearch(false)
            if (!didClearSearch) {
                setDidClearSearch(true)
            }
            setSearchDropdownArray([])
        }
            
        }
        catch (err) {
            console.log("search error", err)
        }
    };
    useEffect(() => {
    
        // fetchData()
        // onload(params.catPrid)
        setSearchTextOffer('')
        setShowSearchDropDown(false)
    }, [])
    useEffect(() => {
    if (debouncedSearchText && String(debouncedSearchText).trim().length > 3) {
      performSearch(debouncedSearchText);
    } else {

    }
    }, [debouncedSearchText]);
    const fetchData = async (catPrid,categoryName,mpidArray,totalNearByPros) => {
        // const { params } = route
        console.log('fetchData called with:', categoryName, catPrid, mpidArray, totalNearByPros)
        const params = paramsLocation.state || {};
        console.log('ejhejh',params)
        let body = {}
        // console.log('fetchData called with:', categoryName, catPrid, mpidArr, params && params.catItem || params && params.fromDeeplink)
        if ((params && params.catItem) || ([...searchParams.keys()].length > 0) ) {
            if (params && params.catItem) {
                setCategoryName(params && params.catItem.category_name ? params.catItem.category_name : categoryName)
                setCatPrid(params && params.catItem.QF_SERVICE_CATEGORY_PRID ? params.catItem.QF_SERVICE_CATEGORY_PRID : catPrid)
                setMpidArr(params && params.mpidArr ? params.mpidArr : mpidArr)
                setIsLoading(true)
                setServiceSearched(params && params.fromServiceSearch ? true : false)

            } else {
                setCategoryName(categoryName)
                setCatPrid(catPrid)
                setMpidArr(mpidArray)
                setIsLoading(true)
                setServiceSearched(params && params.fromServiceSearch ? true : false)
            }
            if (params && params.catItem) {
                body = {
                    mpidArr: params && params.mpidArr ? params.mpidArr : mpidArr,
                    catId: params && params.catItem.QF_SERVICE_CATEGORY_PRID ? params.catItem.QF_SERVICE_CATEGORY_PRID : catPrid,
                    catName: params && params.catItem.category_name ? params.catItem.category_name : categoryName,
                }
            }
            else {
                body = {
                    mpidArr: mpidArray,
                    catId: Number(catPrid),
                    catName: categoryName,
                }
            }


            if (params && params.mpidArr && params.mpidArr.length > 0 || mpidArr.length > 0 || mpidArray.length > 0) {
                console.log('body in fetchData before api call', body)
                let proFetchData = await customFetchData('POST', body, '/website/fetch/category/professionals', state, dispatch)
                console.log('proFetchData', proFetchData)
                if (proFetchData.fetch) {
                    if (proFetchData.fetchedData && proFetchData.fetchedData.professionals && proFetchData.fetchedData.professionals.length > 0) {
                        setFilteredSubCats(proFetchData.fetchedData.subcategories)
                        setSubLoading(false)
                        setProLoading(false)
                        setIsLoading(false)
                        setOfferData(proFetchData.fetchedData.offerData ? proFetchData.fetchedData.offerData : [])
                        // Create a map of all professional details from nearByPros
                        console.log('nearByPros before distance', totalNearByPros)
                        const proDetailsMap = {};
                        if (totalNearByPros && Array.isArray(totalNearByPros) && totalNearByPros.length > 0) {
                            totalNearByPros.forEach(pro => {
                                proDetailsMap[pro.QF_MERCHANT_PERSONNEL_PRID] = pro;
                            });
                        }

                        // Merge all details from nearByPros into professionals
                        const professionalsWithDetails = proFetchData.fetchedData.professionals.map(pro => ({
                            ...pro,
                            ...(proDetailsMap[pro.QF_MERCHANT_PERSONNEL_PRID] || {})
                        }));
                        console.log('professionalsWithDetails', professionalsWithDetails)
                        let sortedByDistanceProsArray = [...professionalsWithDetails]
                            .filter(proArr => proArr.distance !== undefined && proArr.distance !== null)
                            .sort((a, b) => a.distance - b.distance);

                        // setCatMpidArr(proFetchData.fetchedData.catMpidArr)
                        console.log('sortedByDistanceProsArray', sortedByDistanceProsArray)
                        setNearByPros(sortedByDistanceProsArray)
                        setFilteredNearByPros(sortedByDistanceProsArray)
                        setDisplayCount(proFetchData.fetchedData.displayCount)
                        setReviewCount(proFetchData.fetchedData.reviewCount)
                        setCatVideoLink(proFetchData.fetchedData.catVideoLink)
                        setCatRating(proFetchData.fetchedData.catRating)
                        setRandomRating(proFetchData.fetchedData.RandomRating ? proFetchData.fetchedData.RandomRating : 4.5)
                    }
                    else {
                        setFilteredSubCats([])
                        setSubLoading(false)
                        setProLoading(false)
                        setNearByPros([])
                        setFilteredNearByPros([])
                        setDisplayCount(10)
                        setReviewCount(10)
                        setCatVideoLink('')
                        setRandomRating(proFetchData.fetchedData.RandomRating ? proFetchData.fetchedData.RandomRating : 4.5)
                    }
                }
                else {
                    setFilteredSubCats([])
                    setSubLoading(false)
                    setProLoading(false)
                    setNearByPros([])
                    setFilteredNearByPros([])
                    setDisplayCount(10)
                    setReviewCount(10)
                    setCatVideoLink('')
                    setRandomRating(proFetchData.fetchedData.RandomRating ? proFetchData.fetchedData.RandomRating : 4.5)


                }
            }
        }
    }
    const searchBoxOfferhandler = (event) => {
        try {
            setSearchTextOffer(event.target.value)
        }
        catch (cErr) {
            console.log(cErr)
        }
    }
    let searchOfferDropDownItem
    if (nearByPros.length !== 0 && filteredNearByPros.length !== 0 && showSearchDropDown) {
        if (searchDropdownArray.length !== 0) {
            searchOfferDropDownItem = searchDropdownArray.map((item, index) => {
                return (
                    <div style={{ zIndex: 2000 }}>
                        {item.type === 'Professional' ?
                            <div onClick={() => onPressSearchDropDown(item)} style={{ cursor: 'pointer', backgroundColor: '#fff', borderBottom: '1px solid rgba(216, 197, 252, 0.6)', paddingTop: 10, paddingBottom: 10 }}>
                                <div style={{ display: 'flex', flexDirection: 'row', marginLeft: 25 }}>
                                    <div className={"imageProStyle"}>
                                        <img src={item.image_link} style={{ width: 44, height: 44, borderRadius: 7 }} />
                                    </div>
                                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', marginLeft: 22 }}>
                                        <text className={"searchDropDowntextStyle_puc"}>{item.MERCHANT_NAME}</text>
                                        <text className={"searchDropDownSubtextStyle_puc"}>{item.type}</text>
                                    </div>
                                </div>
                            </div>
                            : null}

                        {item.type === 'Service' ?
                            <div onClick={() => onPressSearchDropDown(item)} style={{ cursor: 'pointer', backgroundColor: '#fff', borderBottom: '1px solid rgba(216, 197, 252, 0.6)', paddingTop: 10, paddingBottom: 10 }}>
                                <div style={{ display: 'flex', flexDirection: 'row', marginLeft: 25 }}>
                                    <div className={"imageProStyle"}>
                                        <img src={item.image_link} style={{ width: 44, height: 44, borderRadius: 7 }} />
                                    </div>
                                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', marginLeft: 22 }}>
                                        <text className={"searchDropDowntextStyle_puc"}>{item.SERVICE_NAME}</text>
                                        <text className={"searchDropDownSubtextStyle_puc"}>{item.type}</text>
                                    </div>
                                </div>
                            </div>
                            : null}
                    </div>
                )
            })
        }
        else {
             searchOfferDropDownItem = (
             <div style={{ marginLeft: 20,marginRight:20, height: 150, justifyContent: "center", alignItems: "center", zIndex: 2000 ,display:'flex'}}>
                 <text style={{ fontSize: 12 }}>{"No results matching your search"}</text>
             </div>
         )
        }
    }

     const onPressSearchDropDown = async (data, recentSearchStore, fromRecentSearches) => {
        // console.log('data.item11',data)
        let filtedCats = []

        if (data.type == 'Professional') {
            setShowSearchDropDown(false)
            setShowSearchDropDown(false)
            setSearchModalOpen(false)
            setSearchTextOffer('')
            navigate({ pathname: `/instore/allservices/${data.MERCHANT_NAME.replaceAll(" ", "", "g")}`, search: `?proId=${data.QF_MERCHANT_PERSONNEL_PRID}` }, { state: { proData: data,  catId: catPrid} })
            // navigation.navigate("ProfessionalPage", { clickOnAtHome1: clickOnAtHome ? true : false, proData: data })       
        }
        if (data.type == 'Service') {
            setShowSearchDropDown(false)
            setSerSearchProsLoading(true)
            setServiceSearched(true)
            let matchesArr = []
            matchesArr.push(data)
            if (matchesArr.length !== 0) {
                // setSearchModalOpen(false)
                // setSearchTextOffer('')
                let reqBody = {
                    mpidArr: mpidArr,
                    catMpidArr: catMpidArr,
                    catId: catPrid,
                    // cprid: state.user.id ? state.user.id : null,
                    catName: categoryName,
                    searchServiceText: data.SERVICE_NAME,
                }
                console.log('reqBody in search dropdown', reqBody)
                let searchData = await customFetchData('POST', reqBody, '/website/fetch/search/serviceData', state, dispatch)
                console.log('searchData', searchData)
                if (searchData.fetch) {
                    if (searchData.fetchedData && searchData.fetchedData.professionalCards.length !== 0) {
                        // Create a map for quick lookup of professional details
                        setSerSearchProsLoading(false)
                        let finalPros = []
                        nearByPros.forEach(offer => {
                            searchData.fetchedData.professionalCards.forEach(item => {
                                if (item.QF_MERCHANT_PERSONNEL_PRID === offer.QF_MERCHANT_PERSONNEL_PRID) {
                                    finalPros.push({ ...offer, ...item })
                                }
                            })
                        })
                        console.log('finalPros', finalPros)
                        setServiceSearchPros(finalPros)
                        setSearchModalOpen(true)
                    }
                    else {
                        setSerSearchProsLoading(false)
                        // setSearchDropdownArray([])
                    }
                }
                else {
                    setSerSearchProsLoading(false)
                    // setSearchDropdownArray([])
                }
            }
            else {
                setSearchTextOffer(data.SERVICE_NAME)
                setRecentResultsNotFound(true)
            }      
        }
        // let body = {
        //     mprid: data.QF_MERCHANT_PERSONNEL_PRID ? data.QF_MERCHANT_PERSONNEL_PRID : null,
        //     servicePrid: data.QF_MERCHANT_SERVICE_PRID ? data.QF_MERCHANT_SERVICE_PRID : null,
        //     catPrid: data.QF_SERVICE_CATEGORY_PRID ? data.QF_SERVICE_CATEGORY_PRID : null,
        //     type: data.type == 'Professional' ? 'pro_search' : data.type == 'Category' ? 'cat_search' : data.type == 'Service' ? 'service_search' : null,
        //     diviceId: global.deviceUniqueId,
        //     cPrid: state.user.id,
        //     item: data

        // }
        // let silentCall = true
        // //  console.log('body',body)
        // let searchDataUpdate = useFetchData('POST', body, '/consumer/search/data/update', state, dispatch, null, null, null, silentCall)
        // console.log('searchDataUpdate', searchDataUpdate)

    }

    const clearSearchResults = () => {
        setSearchTextOffer("")
        setShowSearchDropDown(false)
        setClickOnOfferSearch(false)
        // onApplyFilters(false, true)
        onload(catPrid)
        setDidClearSearch(true)
        setSearchSamePage(false)
        setSearchDropdownArray([])

    }

    const next = () => {
        // if (animating) return;
        const nextIndex = activeIndex === MerchantItems.length - 1 ? 0 : activeIndex + 1;
        setActiveIndex(nextIndex);
    };

    const previous = () => {
        // if (animating) return;
        const nextIndex = activeIndex === 0 ? MerchantItems.length - 1 : activeIndex - 1;
        setActiveIndex(nextIndex);
    };
    const goToIndex = (newIndex) => {
        //   console.log("newIndex",newIndex)
        // if (this.animating) return;
        setActiveIndex(newIndex);

    }
    let widthCal;
    widthCal = '80%'
    if (isTabView) {
        widthCal = '95%'
    }
    const onPressProCard = (item) => {
        console.log('onPressProCard', item,paramsLocation.state)
        if (paramsLocation.state) {

            if (paramsLocation.state.fromSearch || searchSamePage) {
                console.log('item', item)
                let offers;
                offers = nearByPros.filter(item1 => {
                    if (item1[0].QF_MERCHANT_PERSONNEL_PRID == item.QF_MERCHANT_PERSONNEL_PRID) {
                        return item1
                    }
                })
                // console.log('offers',offers)
                if (offers.length !== 0) {
                    navigate({ pathname: `/instore/allservices/${item.MERCHANT_NAME.replaceAll(" ", "", "g")}`, search: `?proId=${item.QF_MERCHANT_PERSONNEL_PRID}` }, { state: { proData: item, offers: offers[0], singleService: item, catId: catPrid,fromPucWishList:true, proChecked: checked['checked_' + item.QF_MERCHANT_PERSONNEL_PRID] ? true : false,
                    categories: DeepClone(state.categories), subCategories: DeepClone(state.subcategories),
                    addressDetails:
                    {
                        totalAddress: state.address.totalAddress,
                        addressLine1: state.address.addressLine1,
                        country: state.address.country,
                        city: state.address.city,
                        stateOrProvince: state.address.stateOrProvince,
                        zipcode: state.address.zipcode,
                        district: state.address.district,
                        latitude: state.address.latitude,
                        longitude: state.address.longitude,
                        currentAddress: state.address.currentAddress,
                        searchAddress: state.address.searchAddress,
                        currentLocationDenied: state.address.currentLocationDenied
                    },
                 allServices:nearByPros } })

                }
            }
            else {
                console.log('item', item)
                let subId;
                // navigate('/professionalPage', { state: { proData: item[0], offers: item, catId: catPrid, subcatId: subCatPrid, fromPfu: subCatPrid !== null ? true : (catPrid != 0 ? true : false), proChecked: checked['checked_' + item[0].QF_MERCHANT_PERSONNEL_PRID] ? true : false } })
                navigate({ pathname: `/instore/allservices/${item.MERCHANT_NAME.replaceAll(" ", "", "g")}`, search: `?proId=${item.QF_MERCHANT_PERSONNEL_PRID}` }, { state: { proData: item, offers: item, catId: catPrid, subcatId: subCatPrid,fromPucWishList:true, fromPfu: subCatPrid !== null ? true : (catPrid != 0 ? true : false), proChecked: checked['checked_' + item.QF_MERCHANT_PERSONNEL_PRID] ? true : false,
                categories: DeepClone(state.categories), subCategories: DeepClone(state.subcategories),
                addressDetails:
                {
                    totalAddress: state.address.totalAddress,
                    addressLine1: state.address.addressLine1,
                    country: state.address.country,
                    city: state.address.city,
                    stateOrProvince: state.address.stateOrProvince,
                    zipcode: state.address.zipcode,
                    district: state.address.district,
                    latitude: state.address.latitude,
                    longitude: state.address.longitude,
                    currentAddress: state.address.currentAddress,
                    searchAddress: state.address.searchAddress,
                    currentLocationDenied: state.address.currentLocationDenied
                },
             allServices:nearByPros } })

            }
        }
        else {
            console.log('item', item)
            let subId;
            // navigate('/professionalPage', { state: { proData: item[0], offers: item, catId: catPrid, subcatId: subCatPrid, fromPfu: subCatPrid !== null ? true : (catPrid != 0 ? true : false), proChecked: checked['checked_' + item[0].QF_MERCHANT_PERSONNEL_PRID] ? true : false } })
            navigate({ pathname: `/instore/allservices/${item.MERCHANT_NAME.replaceAll(" ", "", "g")}`, search: `?proId=${item.QF_MERCHANT_PERSONNEL_PRID}` }, { state: { proData: item, offers: item, catId: catPrid, subcatId: subCatPrid, fromPfu: subCatPrid !== null ? true : (catPrid != 0 ? true : false), proChecked: checked['checked_' + item.QF_MERCHANT_PERSONNEL_PRID] ? true : false ,
            categories: DeepClone(state.categories), subCategories: DeepClone(state.subcategories),
            addressDetails:
            {
                totalAddress: state.address.totalAddress,
                addressLine1: state.address.addressLine1,
                country: state.address.country,
                city: state.address.city,
                stateOrProvince: state.address.stateOrProvince,
                zipcode: state.address.zipcode,
                district: state.address.district,
                latitude: state.address.latitude,
                longitude: state.address.longitude,
                currentAddress: state.address.currentAddress,
                searchAddress: state.address.searchAddress,
                currentLocationDenied: state.address.currentLocationDenied
            },
         allServices:nearByPros} })
        }

    }
    // Sub-Categories display
    let subItems;
    if (filteredSubCats.length !== 0) {
        subItems = (
            <div className='subcat_display_main'>
                {

                    filteredSubCats.map((item, index) => {
                        return (
                            <div onClick={() => onPressSubCategory(item.QF_SERVICE_SUB_CATEGORY_PRID,item.service_sub_category_name)} style={{flexDirection:'column',display:'flex',marginRight:60,border:item.QF_SERVICE_SUB_CATEGORY_PRID === subCatPrid ? '2px solid #8c52ff': '',padding:'8px'}} >
                                {/* <div style={{borderColor: item.QF_SERVICE_SUB_CATEGORY_PRID === subCatPrid ? '#8c52ff' : '#fff',borderWidth: item.QF_SERVICE_SUB_CATEGORY_PRID === subCatPrid ? 1.5 : 0}}> */}
                                <img className='subcat_img-displayy' src={subcatImages[item.service_sub_category_name.trim()] ? subcatImages[item.service_sub_category_name.trim()] : 'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753780019158-lg.webp'} />
                                {/* </div> */}
                                <text style={{ textAlign: 'center',color:item.QF_SERVICE_SUB_CATEGORY_PRID === subCatPrid ? '#8c52ff': '#747474' }} className='sub_name_sv2'>{item.service_sub_category_name}</text>
                            </div>
                        )
                    })
                }
            </div>
        )

    }
    else {
        if (subLoading && filteredSubCats.length == 0) {
            subItems = (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 15 }}>
                    <text className='no_pro_style'>No sub categories found.</text>
                </div>
            )
        }
    }
    // console.log('params location',paramsLocation.state)
    let proCards;
    if (nearByPros.length !== 0) {
        if (filteredNearByPros.length !== 0) {

            proCards = (
                <div className='proCardsContainer'>
                    {

                        filteredNearByPros.map((item, index) => {
                            return (
                                <div>
                                    <NewProfessionalCard state={state} categoryName={categoryName} serviceCount={item.SERVICE_COUNT} serviceName={item.SERVICE_NAME} servicePriceCurrency={item.MERCHANT_PERSONNEL_TIMEZONE === "Asia/Kolkata" ? '\u20B9' : "$"} fromServiceSearch={serviceSearched} proData={item} isLast={index === filteredNearByPros.length - 1} proArray={item} onPressCard={() => onPressProCard(item)} />
                                </div>
                            )
                        })
                    }
                </div>
            )
        }
        else {
            proCards = (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 15 }}>
                    <text className='no_pro_style'>Currently there are no Professionals for the selected filters. Please change the filters and try again.</text>
                </div>
            )
        }
    }
    else {
        if (nearByPros.length == 0 && proLoading) {
            proCards = (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 15 }}>
                    <text className='no_pro_style'>No Professionals found</text>
                </div>
            )

        }
    }
    const onPressFilters = () => {
        setFiltersModal(true)
    }
    const toggleExpandedDate = () => {
        setDateCollapsed(!dateCollapsed);
    };
    const toggleExpandedTime = () => {
        setTimeCollapsed(!timeCollapsed);
    }
    const toggleExpandedPrice = () => {
        setPriceCollapsed(!priceCollapsed);
    };
    const toggleExpandedDistance = () => {
        setDistanceCollapsed(!distanceCollapsed);
    };
    const handleDatePicked = (date) => {
        // console.log('date value in date picker', date)
        let day = "", month = "", year = "";
        day = date.getDate(); month = date.getMonth(); year = date.getFullYear();
        // hideDateTimePicker()
        setFromDateTime(fromDateTime.set({ 'year': year, 'month': month, 'date': day }))
        //// setting from and to date in global state
        // dispatch({type:'SET_FROM_DATE_TIME',fromDateTime:fromDateTime.set({ 'year': year, 'month': month, 'date': day })})  
        let fromDateTime1 = fromDateTime.set({ 'year': year, 'month': month, 'date': day })
        storeDateAndTime(fromDateTime1, toDateTime, dispatch)
        // setIsCancel(isCancel ? !isCancel : isCancel)
    };
    const handleDatePicked1 = (date) => {
        console.log("date in hp1", fromDateTime);
        // hideDateTimePicker1();
        let day = "", month = "", year = "";
        day = date.getDate(); month = date.getMonth(); year = date.getFullYear();
        setToDateTime(toDateTime.set({ 'year': year, 'month': month, 'date': day }))
        //// setting to date in global state
        // dispatch({type:'SET_TO_DATE_TIME',toDateTime:toDateTime.set({ 'year': year, 'month': month, 'date': day })})
        let toDateTime1 = toDateTime.set({ 'year': year, 'month': month, 'date': day })
        storeDateAndTime(fromDateTime, toDateTime1, dispatch)
    };
    const handleDatePicked2 = (time) => {
        // hideDateTimePicker2();
        console.log('time value', time)
        let hour = "", min = "";
        if (time !== null) {
            // time.split(":");
            let hours = time.split(":");
            console.log(hours, 'hours', hours[0],)

            hour = hours[0] ? hours[0] : '00'
            min = hours[1] ? hours[1] : '00'
        }
        setSelectedBTimes((prevState) => {
            return {
                ...prevState,
                fromTime: moment().set({ 'hour': hour, 'minute': min })
            }
        })
        setFromHours(hour)

        // setFromDateTime(fromDateTime.set({ 'hour': hour, 'minute': min }))
        //// setting from and to date in global state
        // dispatch({type:'SET_FROM_DATE_TIME',fromDateTime:fromDateTime.set({ 'hour': hour, 'minute': min })})
        let fromDateTime1 = fromDateTime.set({ 'hour': hour, 'minute': min })
        storeDateAndTime(fromDateTime1, toDateTime, dispatch)
        //  setIsCancel2(isCancel3 ? !isCancel3 : isCancel3
    };
    // const hideDateTimePicker3 = () => setIsDateTimePickerVisible3(false);
    const handleDatePicked3 = (time) => {
        // hideDateTimePicker3();
        // let hour = "", min = "";
        // hour = time.getHours(); min = time.getMinutes()
        // setToDateTime(toDateTime.set({ 'hour': hour, 'minute': min }))
        let hour = "", min = "";

        if (time !== null) {
            // time.split(":");
            let hours = time.split(":");
            hour = hours[0] ? hours[0] : '00'
            min = hours[1] ? hours[1] : '00'
        }
        setSelectedBTimes((prevState) => {
            return {
                ...prevState,
                toTime: moment().set({ 'hour': hour, 'minute': min })
            }

        })
        setToHours(hour)
        //// setting to date in global state
        // dispatch({type:'SET_TO_DATE_TIME',toDateTime:toDateTime.set({ 'hour': hour, 'minute': min })})
        let toDateTime1 = toDateTime.set({ 'hour': hour, 'minute': min })
        storeDateAndTime(fromDateTime, toDateTime1, dispatch)
    }
    const onChangeSliderValues = (values) => {
        setPriceMin(values[0])
        setPriceMax(values[1])
    }
    const onChangeDistanceSliderValues = (values) => {
        setDistanceMin(values[0])
        setDistanceMax(values[1])
    }
    const onPressRatings = () => {
        // console.log(sortRatings)
        if (!sortRatings) {
            setSortRatings(true)
            setSortDiscount(false)
            // Sorting by ratings - high to low
            let newOffers = DeepClone(filteredNearByPros)
            newOffers.sort((a, b) => {
                return (b[0].MERCHANT_PERSONNEL_RATING ? b[0].MERCHANT_PERSONNEL_RATING : 0) - (a[0].MERCHANT_PERSONNEL_RATING ? a[0].MERCHANT_PERSONNEL_RATING : 0)
            });
            setFilteredNearByPros(newOffers)
        }
        else {
            setSortRatings(false)
            setSortDiscount(false)
        }
    }

    const onPressDiscounts = () => {
        if (!sortDiscount) {
            setSortRatings(false)
            setSortDiscount(true)
            // Sorting by Discounts - high to low
            let newOffers = DeepClone(filteredNearByPros)
            // console.log('services', newOffers)
            newOffers.map((item, index) => {
                item.sort((a, b) => {
                    return b.service_discount - a.service_discount
                })
            })
            newOffers.sort((a, b) => {
                return b[0].service_discount - a[0].service_discount
            });
            setFilteredNearByPros(newOffers)
        }
        else {
            setSortRatings(false)
            setSortDiscount(false)
        }
    }
    const onCatSelection = async (cat_item) => {
        const params = paramsLocation.state || {};
        let totalNearByPros = DeepClone(paramsLocation.state.nearByPros) || DeepClone(nearByPros)
        console.log('cat_item', cat_item)
        let body = {
            // mpidArr: mpidArr,
            // catId: catPrid,
            // catName: categoryName,
            mpidArr: params && params.mpidArr ? params.mpidArr : mpidArr,
            // mpidArr: mpidArr,
            // catId: params && params.catItem.QF_SERVICE_CATEGORY_PRID ? params.catItem.QF_SERVICE_CATEGORY_PRID : catPrid,
            catId : cat_item && cat_item.QF_SERVICE_CATEGORY_PRID,
            // catId: 17,
            // catName: params && params.catItem.category_name ? params.catItem.category_name : categoryName,
            catName : cat_item && cat_item.category_name,
            // catName: 'Beauty'
        }

        setSelectedCatPrid(cat_item && cat_item.QF_SERVICE_CATEGORY_PRID)
        setCategoryName(cat_item && cat_item.category_name)
        console.log('body in puc', body)
        if (mpidArr.length > 0) {
            let proFetchData = await customFetchData('POST', body, '/website/fetch/category/professionals', state, dispatch)
            console.log('proFetchData', proFetchData)
            if (proFetchData.fetch) {
                    if (proFetchData.fetchedData && proFetchData.fetchedData.professionals && proFetchData.fetchedData.professionals.length > 0) {
                        setFilteredSubCats(proFetchData.fetchedData.subcategories)
                        setSubLoading(false)
                        setProLoading(false)
                        setIsLoading(false)
                        setOfferData(proFetchData.fetchedData.offerData ? proFetchData.fetchedData.offerData : [])
                        // Create a map of all professional details from nearByPros
                        console.log('nearByPros before distance', totalNearByPros)
                        const proDetailsMap = {};
                        if (totalNearByPros && Array.isArray(totalNearByPros) && totalNearByPros.length > 0) {
                            totalNearByPros.forEach(pro => {
                                proDetailsMap[pro.QF_MERCHANT_PERSONNEL_PRID] = pro;
                            });
                        }

                        // Merge all details from nearByPros into professionals
                        const professionalsWithDetails = proFetchData.fetchedData.professionals.map(pro => ({
                            ...pro,
                            ...(proDetailsMap[pro.QF_MERCHANT_PERSONNEL_PRID] || {})
                        }));
                        console.log('professionalsWithDetails', professionalsWithDetails)
                        let sortedByDistanceProsArray = [...professionalsWithDetails]
                            .filter(proArr => proArr.distance !== undefined && proArr.distance !== null)
                            .sort((a, b) => a.distance - b.distance);

                        // setCatMpidArr(proFetchData.fetchedData.catMpidArr)
                        console.log('sortedByDistanceProsArray', sortedByDistanceProsArray)
                        setNearByPros(sortedByDistanceProsArray)
                        setFilteredNearByPros(sortedByDistanceProsArray)
                        setDisplayCount(proFetchData.fetchedData.displayCount)
                        setReviewCount(proFetchData.fetchedData.reviewCount)
                        setCatVideoLink(proFetchData.fetchedData.catVideoLink)
                        setCatRating(proFetchData.fetchedData.catRating)
                        setRandomRating(proFetchData.fetchedData.RandomRating ? proFetchData.fetchedData.RandomRating : 4.5)
                    }
                    else {
                        setFilteredSubCats([])
                        setSubLoading(false)
                        setProLoading(false)
                        setNearByPros([])
                        setFilteredNearByPros([])
                        setDisplayCount(10)
                        setReviewCount(10)
                        setCatVideoLink('')
                        setRandomRating(proFetchData.fetchedData.RandomRating ? proFetchData.fetchedData.RandomRating : 4.5)
                    }
                }
                else {
                    setFilteredSubCats([])
                    setSubLoading(false)
                    setProLoading(false)
                    setNearByPros([])
                    setFilteredNearByPros([])
                    setDisplayCount(10)
                    setReviewCount(10)
                    setCatVideoLink('')
                    setRandomRating(proFetchData.fetchedData.RandomRating ? proFetchData.fetchedData.RandomRating : 4.5)


                }
        }
    }
    const onPressReset = (fromClick) => {
        let prevFilters = {};
        console.log("merchantTimeZone", merchantTimeZone)
        // this.state.subcats.map((item, index) => {
        //     subcatCheck["subcheck_" + item.qf_service_sub_category_prid] = true;
        // })

        // if (fromClick) 
        // {
        //     prevFilters.distanceMin = distanceMin;
        //     prevFilters.distanceMax = distanceMax;
        //     // prevFilters.subcatCheck = this.state.subcatCheck;
        //     prevFilters.ratingsMin = ratingsMin;
        //     prevFilters.ratingsMax = ratingsMax;
        // }

        setDistanceMin(0)
        setDistanceMax(state.address.country === 'India' ? 20 : 25)

        setPriceMin(0)
        setPriceMax(state.address.country == 'India' ? 15000 : 5000)

        setFromDateTime(moment().tz(merchantTimeZone).set({ 'hour': 0, 'minute': 0 }))
        setToDateTime(moment().tz(merchantTimeZone).set({ 'hour': 23, 'minute': 59 }).add(14, "days"))

        //// setting from and to date in global state
        let fromDateTime = moment().tz(merchantTimeZone).set({ 'hour': 0, 'minute': 0 })
        let toDateTime = moment().tz(merchantTimeZone).set({ 'hour': 23, 'minute': 59 }).add(14, "days")
        storeDateAndTime(fromDateTime, toDateTime, dispatch)
        // dispatch({type:'SET_FROM_DATE_TIME',fromDateTime:moment().tz(merchantTimeZone).set({ 'hour': 0, 'minute': 0 })})
        // dispatch({type:'SET_TO_DATE_TIME',toDateTime:moment().tz(merchantTimeZone).set({ 'hour': 23, 'minute': 59 }).add(14, "days")})
        setSelectedBTimes((prevState) => {
            return {
                ...prevState,
                fromTime: moment().set({ 'hour': 0, 'minute': 0 }),
                toTime: moment().set({ 'hour': 23, 'minute': 59 })
            }
        })

        setOnClickReset(fromClick ? true : false)
        // setPrevFilters((prevState) => {
        //     return {
        //         ...prevState,
        //         prevFilters: prevState.onClickReset ? prevState.prevFilters : prevFilters,
        //     }
        // })
        // prevFilters:prevState.prevFilters
    }
    const getLatestCalAvailabilityOfPros = (checkAndFetchDistance, distanceBody) => {
        return new Promise(async (resolve, reject) => {
            let offers1 = DeepClone(nearByPros), backToArr1 = [], backToArr2 = [], filterArr1 = [], filterArr2 = [];
            let cats = DeepClone(state.categories), subcats = DeepClone(state.subcategories)
            offers1.map((item1) => {
                backToArr1 = item1.filter(item2 => {

                    return ((distanceMin <= (item2.SERVICE_CURRENCY === 'Rupees' ? curr(item2.distance).divide(1000).value : curr(item2.distance).divide(1609.344).value)) && ((item2.SERVICE_CURRENCY === 'Rupees' ? curr(item2.distance).divide(1000).value : curr(item2.distance).divide(1609.344).value) <= distanceMax))
                })
                if (backToArr1.length !== 0) {
                    backToArr2.push(backToArr1[0].QF_MERCHANT_PERSONNEL_PRID);
                }
            });

            if (backToArr2.length !== 0) {

                let reqToSend = {
                    fromDate: fromDateTime.format("YYYY-MM-DD HH:mm:ss"),
                    toDate: toDateTime.format("YYYY-MM-DD HH:mm:ss"),
                    mArray: backToArr2,
                    checkAndFetchDistance,
                    ...distanceBody
                }
                console.log("diffDaysFront",reqToSend)

                let { fetchedData } = await customFetchData('POST', reqToSend, '/website/dateandtime/filters/sv2', state, dispatch)
                console.log("from get cal pro availability", fetchedData)
                if (fetchedData.data) 
                {
                    let merchTrueObj = fetchedData.merchTrueObj
                    console.log("offers1 before", offers1.length, fetchedData.newServices.length)
                    if (fetchedData.newServices.length !== 0) {
                        fetchedData.newServices.forEach(outerItem => {
                            offers1.push(outerItem)
                        })

                        fetchedData.newCatsFinal.forEach(catItemNew => {
                            if (!cats.some(catItem => catItem.category_name == catItemNew.category_name)) {
                                cats.push(catItemNew)
                            }
                        })
                        console.log("new cats", cats)
                        fetchedData.newSubCatsFinal.forEach(subcatItemNew => {
                            if (!cats.some(subcatItem => subcatItem.service_sub_category_name == subcatItemNew.service_sub_category_name)) {
                                subcats.push(subcatItemNew)
                            }
                        })
                        console.log("new subcats", subcats)

                        // fetchedData.newSubCatsFinal
                        // offers1.map((item, index) => {
                        //     item.sort((a, b) => {
                        //         return moment(b.SERVICE_UPDATED_ON_DATE).diff(moment(a.SERVICE_UPDATED_ON_DATE))
                        //     })
                        // })
                        // offers1.sort((a, b) => {
                        //     return moment(b[0].SERVICE_UPDATED_ON_DATE).diff(moment(a[0].SERVICE_UPDATED_ON_DATE))
                        // });
                        // dispatch({ type: 'SET_SERVICES', services: offers1 })
                        // dispatch({ type: 'SET_CATEGORIES', categories: cats })
                        // dispatch({ type: 'SET_SUBCATEGORIES', subcategories: subcats })
                    }

                    console.log("offers1 before", offers1.length)
                    for (let prop in merchTrueObj) 
                    {
                        offers1.map(outerItem => {
                            filterArr1 = outerItem.filter(innerItem => {
                                return innerItem.QF_MERCHANT_PERSONNEL_PRID == prop && innerItem.SERVICE_DURATION_IN_MINS <= (merchTrueObj[prop] === 0 ? 480 : merchTrueObj[prop])
                            })
                            if (filterArr1.length !== 0) {
                                filterArr2.push(filterArr1)
                            }
                        })
                    }
                    console.log("filterArr2", filterArr2)
                    resolve({ get: true, offers: filterArr2 })
                }
                else {
                    if (fetchedData.dbError) {
                        // ToastAndroid.show("Internal Error. Please try again.", ToastAndroid.LONG);
                    }
                    else if (fetchedData.alreadyIgnored) {
                        // ToastAndroid.show("Service is already ignored.", ToastAndroid.LONG);
                    }
                    else {
                        // ToastAndroid.show("Internal Error. Please try again.", ToastAndroid.LONG);
                    }
                    resolve({ get: false, offers: [] })
                }
            }
            else {
                resolve({ get: false, offers: [] })
            }
        })
    }
    const onload1 = (categoryPrid, nearByPros, categories, subCategories) => {
        console.log('data in puc page', categories, subCategories, nearByPros,)
        // let professionals;
        if (nearByPros.length !== 0) {
            setNearByPros(nearByPros)
            setFilteredNearByPros(nearByPros)
            setProLoading(false)
        }

        if (subCategories.length !== 0) {
            setSubLoading(false)
            let filteredSub = []
            if (categoryPrid != 0) {
                // console.log('in cat prid not null',categoryPrid)
                filteredSub = subCategories.filter((item) => {
                    return item.QF_SERVICE_CATEGORY_PRID === categoryPrid
                })
            }
            else {
                filteredSub = subCategories.filter((item) => {
                    return item
                })
            }
            setFilteredSubCats(filteredSub)
            let subcatToState = {}
            subCategories.map((subcatItem) => {
                // if ( fromCatSearch) {
                //     setSubCatPrid(params.subcatItem.qf_service_sub_category_prid)
                //     if (subcatItem.qf_service_sub_category_prid === params.subcatItem.qf_service_sub_category_prid) {
                //         subcatToState["subcheck_" + subcatItem.qf_service_sub_category_prid] = true;
                //     }
                //     else {
                //         subcatToState["subcheck_" + subcatItem.qf_service_sub_category_prid] = false;
                //     }
                // }
                // else
                // {
                subcatToState["subcheck_" + subcatItem.qf_service_sub_category_prid] = true;
                // }

            })
            setSubcatCheck(subcatToState)
        }
        let filteredPros = [], newOffers2 = [], newOffers1 = []
        // if (route.params.fromExplore && !fromCatSearch) 
        // {
        //     if(route.params.nearByPros.length!==0)
        //     {
        //         route.params.nearByPros.map(item1 => {
        //             newOffers1 = item1.filter(item2 => {
        //                 return item2.QF_SERVICE_CATEGORY_PRID === categoryPrid && item2.QF_SERVICE_SUB_CATEGORY_PRID === route.params.subcatItem.qf_service_sub_category_prid 
        //             })
        //             if (newOffers1.length !== 0) {
        //                 newOffers2.push(newOffers1);
        //             }
        //         })
        //         filteredPros = newOffers2;
        //     }

        // }
        // else 
        // {
        if (nearByPros.length !== 0) {
            nearByPros.map(item1 => {
                // console.log('nearBypros',nearByPros)
                if (categoryPrid != 0) {
                    newOffers1 = item1.filter(item2 => {
                        // console.log('itemsss',item2.QF_SERVICE_CATEGORY_PRID,categoryPrid)
                        return item2.QF_SERVICE_CATEGORY_PRID == Number(categoryPrid)
                    })
                }
                else {
                    newOffers1 = item1.filter(item2 => {
                        return item2
                    })
                }
                // console.log('newoffers1',newOffers1)
                if (newOffers1.length !== 0) {
                    newOffers2.push(newOffers1);
                }
            });
            filteredPros = newOffers2;
            console.log('filteredpros', filteredPros)
        }
        // }
        setFilteredNearByPros(filteredPros)
        // if( paramsLocation.state && paramsLocation.state.fromSearch){
        //     setFilteredNearByPros(paramsLocation.state.selectedServices)
        // }
        // if(fromSearch){
        //     setSearchSamePage(true)
        //     setFilteredNearByPros(finalPros)
        // }
    }
    const onload = (categoryPrid, fromCatSearch, fromSearch, finalPros,) => {
        if (paramsLocation.state) {
            if (paramsLocation.state.nearByPros.length !== 0) {
                setNearByPros(paramsLocation.state.nearByPros)
                setFilteredNearByPros(paramsLocation.state.nearByPros)
                setProLoading(false)
                paramsLocation.state.nearByPros.map(checkedItem => {
                    // console.log('checked item widhlist value',checkedItem)
                    if (checkedItem[0].wishlist_Pro === 0) {
                        return checked['checked_' + checkedItem[0].QF_MERCHANT_PERSONNEL_PRID] = true
                    } else {
                        return checked['checked_' + checkedItem[0].QF_MERCHANT_PERSONNEL_PRID] = false
                    }
                })
            }

            if (paramsLocation.state && paramsLocation.state.subCategories.length !== 0) {
                setSubLoading(false)
                setsubCategories(paramsLocation.state.subCategories)
                let filteredSub = []
                if (categoryPrid != 0) {
                    filteredSub = paramsLocation.state.subCategories.filter((item) => {
                        return item.QF_SERVICE_CATEGORY_PRID === categoryPrid
                    })
                }
                else {
                    filteredSub = paramsLocation.state.subCategories.filter((item) => {
                        return item
                    })
                }
                setFilteredSubCats(filteredSub)
                let subcatToState = {}
                paramsLocation.state.subCategories.map((subcatItem) => {
                    // if ( fromCatSearch) {
                    //     setSubCatPrid(params.subcatItem.qf_service_sub_category_prid)
                    //     if (subcatItem.qf_service_sub_category_prid === params.subcatItem.qf_service_sub_category_prid) {
                    //         subcatToState["subcheck_" + subcatItem.qf_service_sub_category_prid] = true;
                    //     }
                    //     else {
                    //         subcatToState["subcheck_" + subcatItem.qf_service_sub_category_prid] = false;
                    //     }
                    // }
                    // else
                    // {
                    subcatToState["subcheck_" + subcatItem.qf_service_sub_category_prid] = true;
                    // }

                })
                setSubcatCheck(subcatToState)
            }
            let filteredPros = [], newOffers2 = [], newOffers1 = []
            if (paramsLocation.state.nearByPros.length !== 0) {
                paramsLocation.state.nearByPros.map(item1 => {
                    if (categoryPrid != 0) {
                        newOffers1 = item1.filter(item2 => {
                            return item2.QF_SERVICE_CATEGORY_PRID === categoryPrid
                        })
                    }
                    else {
                        newOffers1 = item1.filter(item2 => {
                            return item2
                        })
                    }
                    if (newOffers1.length !== 0) {
                        newOffers2.push(newOffers1);
                    }
                });
                filteredPros = newOffers2;
            }
            // }
            setFilteredNearByPros(filteredPros)
            if (paramsLocation.state && paramsLocation.state.fromSearch) {
                setFilteredNearByPros(paramsLocation.state.selectedServices)
            }
            if (fromSearch) {
                setSearchSamePage(true)
                setFilteredNearByPros(finalPros)
            }
        }
        else {
            if (nearByPros.length !== 0) {
                setNearByPros(nearByPros)
                setFilteredNearByPros(nearByPros)
                setProLoading(false)
                nearByPros.map(checkedItem => {
                    // console.log('checked item widhlist value',checkedItem)
                    if (checkedItem[0].wishlist_Pro === 0) {
                        return checked['checked_' + checkedItem[0].QF_MERCHANT_PERSONNEL_PRID] = true
                    } else {
                        return checked['checked_' + checkedItem[0].QF_MERCHANT_PERSONNEL_PRID] = false
                    }
                })
            }

            if (subCategories.length !== 0) {
                setSubLoading(false)
                setsubCategories(subCategories)
                let filteredSub = []
                if (categoryPrid != 0) {
                    filteredSub = subCategories.filter((item) => {
                        return item.QF_SERVICE_CATEGORY_PRID === categoryPrid
                    })
                }
                else {
                    filteredSub = subCategories.filter((item) => {
                        return item
                    })
                }
                setFilteredSubCats(filteredSub)
                let subcatToState = {}
                subCategories.map((subcatItem) => {
                    subcatToState["subcheck_" + subcatItem.qf_service_sub_category_prid] = true;
                })
                setSubcatCheck(subcatToState)
            }
            let filteredPros = [], newOffers2 = [], newOffers1 = []
            if (nearByPros.length !== 0) {
                nearByPros.map(item1 => {
                    if (categoryPrid != 0) {
                        newOffers1 = item1.filter(item2 => {
                            return item2.QF_SERVICE_CATEGORY_PRID === categoryPrid
                        })
                    }
                    else {
                        newOffers1 = item1.filter(item2 => {
                            return item2
                        })
                    }
                    if (newOffers1.length !== 0) {
                        newOffers2.push(newOffers1);
                    }
                });
                filteredPros = newOffers2;
            }
            // }
            setFilteredNearByPros(filteredPros)
            // if (paramsLocation.state && paramsLocation.state.fromSearch) {
            //     setFilteredNearByPros(paramsLocation.state.selectedServices)
            // }
            if (fromSearch) {
                setSearchSamePage(true)
                setFilteredNearByPros(finalPros)
            }
        }
    }
    // Apply filter function
    const onApplyFilters = async (buttonClicked, fromCross) => {
        setProLoading(true)
        let offers = [], newOffers1 = [], newOffers2 = [], newOffers3 = [], newOffers4 = [], prevFilters = {}, matchesArr = [], checkAndFetchDistance = false, distanceBody = {},merLocFront=[];
        dispatch({ type: 'SET_DISTANCE_MIN', distanceMin })
        dispatch({ type: 'SET_DISTANCE_MAX', distanceMax })
        console.log("call backend check distance", state.distanceCheckMax, distanceMax, state)

        if (state.distanceCheckMax < distanceMax) 
        {

            nearByPros.forEach(item=>{
                merLocFront.push(item[0].QF_MERCHANT_LOCATION_PRID)
            })

            console.log("call backend")
            dispatch({ type: 'SET_DISTANCE_CHECK_MAX', distanceCheckMax: distanceMax })
            distanceBody = {
                curr_lat: state.address.latitude,
                curr_long: state.address.longitude,
                curr_city: state.address.city,
                stateOrProvince: state.address.stateOrProvince,
                countryName: state.address.country,
                distanceMax,
                merLocFront,
                consumerId:state.user.id
            }
            console.log("state", state)
            checkAndFetchDistance = true
            // let {fetchedData} = await customFetchData('POST', body, '/consumer/test/dservicesBasedOnDistance', state, dispatch)
            // console.log("fetchedData dist",fetchedData)
        }


        if (buttonClicked) 
        {
            setApplyButtonLoading(true)
            ///// getting all the Professional where the distance and ratings filters are getting satisfied
            let calFilteredOffers = await getLatestCalAvailabilityOfPros(checkAndFetchDistance, distanceBody)
            console.log("calFilteredOffers", calFilteredOffers)
            if (calFilteredOffers.get) 
            {
                offers = DeepClone(calFilteredOffers.offers)
                setCalFilteredOffers(offers)
            }
            else {
                offers = DeepClone(nearByPros)
            }

        }
        else 
        {
            offers = DeepClone(nearByPros)
        }
        // console.log("offers before map on apply filters",offers)
        if (catPrid != 0) {
            offers.map(item1 => {
                newOffers1 = item1.filter(item2 => {
                    return item2.QF_SERVICE_CATEGORY_PRID === catPrid;
                })
                if (newOffers1.length !== 0) {
                    newOffers2.push(newOffers1);
                }
            });
        }
        else {
            offers.map(item1 => {
                newOffers1 = item1.filter(item2 => {
                    return item2
                })
                if (newOffers1.length !== 0) {
                    newOffers2.push(newOffers1);
                }
            });
        }
        offers = []
        offers = DeepClone(newOffers2)

        // console.log("offers before map on apply filters2",offers)

        offers.map((item1) => {
            newOffers3 = item1.filter(item2 => {
                // console.log("on press apply",fromDateTime.get("minutes"),"  ",moment(item2.MERCHANT_OFFER_FROM_DATE_TIME+"Z").tz(merchantTimezone).get("minutes"),"  ",toDateTime.get("minutes")," ",moment(item2.MERCHANT_OFFER_TO_DATE_TIME+"Z").tz(merchantTimezone).get("minutes")," ",item2.QF_MERCHANT_SERVICE_PRID);
                return (subcatCheck["subcheck_" + item2.QF_SERVICE_SUB_CATEGORY_PRID] === true)
                    &&
                    ((priceMin <= item2.service_offer_price) && (item2.service_offer_price <= priceMax))
                    &&
                    ((distanceMin <= (item2.SERVICE_CURRENCY === 'Rupees' ? curr(item2.distance).divide(1000).value : curr(item2.distance).divide(1609.344).value)) && ((item2.SERVICE_CURRENCY === 'Rupees' ? curr(item2.distance).divide(1000).value : curr(item2.distance).divide(1609.344).value) <= distanceMax))

            })
            if (newOffers3.length !== 0) {
                newOffers4.push(newOffers3);
            }
        })
        // console.log("offers before map on apply filters3",newOffers4)

        // // console.log('newoffers3',newOffers3)
        // newOffers3 = newOffers3.filter(item2 => {
        //         return item2.QF_SERVICE_CATEGORY_PRID === catPrid
        // })
        // if (newOffers3.length !== 0) {
        //     newOffers3 = Object.values(newOffers3.reduce((acc, cur) => Object.assign(acc, { [cur.QF_MERCHANT_PERSONNEL_PRID]: cur }), {}))
        // }
        // if (newOffers3.length !== 0) {
        //     newOffers4.push(newOffers3);
        //     // console.log('new offers3',newOffers3)
        // }
        // // })
        if (!fromCross) {
            if (searchClickedValue && clickOnOfferSearch) {
                if (newOffers4.length !== 0) {
                    newOffers4.map((outerItem) => {
                        outerItem.map((insideItem) => {
                            if (insideItem.MERCHANT_NAME === searchClickedValue) {
                                matchesArr.push([insideItem])
                            }
                        })
                    })
                }
                newOffers4 = DeepClone(matchesArr)
            }
        }
        // console.log("offers before map on apply filters4",newOffers4)

        if (sortRatings) {
            //// Sorting by ratings - high to low
            newOffers4.sort((a, b) => {
                return (b[0].MERCHANT_PERSONNEL_RATING ? b[0].MERCHANT_PERSONNEL_RATING : 0) - (a[0].MERCHANT_PERSONNEL_RATING ? a[0].MERCHANT_PERSONNEL_RATING : 0)
            });
        }

        if (sortDiscount) {
            //// Sorting by Discount - high to low
            newOffers4.map((item, index) => {
                item.sort((a, b) => {
                    return b.service_discount - a.service_discount
                })
            })
            newOffers4.sort((a, b) => {
                return b[0].service_discount - a[0].service_discount
            });
        }

        // console.log("offers before map on apply filters5",newOffers4)
        // prevFilters.distanceMin = distanceMin;
        // prevFilters.distanceMax = distanceMax;
        // prevFilters.ratingsMin = ratingsMin;
        // prevFilters.ratingsMax = ratingsMax;
        // if(newOffers4.length == 0 ){
        //     setProLoading(false)
        // }
        setFilteredNearByPros(newOffers4.length !== 0 ? newOffers4 : [])
        setFiltersModal(false)
        setApplyButtonLoading(false)
        setProLoading(false)
        setOnApplyClick(true)
        setPrevFilters(prevFilters)
        setOnClickReset(false)
        setOnApplyClick2(buttonClicked ? true : false)
    }
    if(titleOptions.length>0){
     title = titleOptions.join(" | ")
    }

    const categoryDescriptions = {
        "Beauty": `skin bleaching, skin whitening, skin lightening, skin fairness treatment, face whitening, de-tan treatment for women, de-tan treatment for men, detan facial, face clean up, women clean up 
                      facial, best skin exfoliator, skin exfoliation treatment, skin exfoliate facial, skin exfoliator treatment, skin whitening near me, face clean up near me, detan treatment near me`,

        "Hair Care": `  Hair color, Hair colour, Hair dye, hair colors for guys, hair colors for girls, hair colors for women,
                            hair colors for males, hair colors for females, natural hair dye, best hair dye, ppd free hair dye, Blonde hair color, hair styling, 
                            hair cut, hair styling, near me, low fade hairstyle, mullet haircut, curly hair styling, near me, bob cut, layered haircut, butterfly haircut
                            keratin treatment , dandruff treatment , hair mask , hair spa , hair dressing ,  hair setting , 
                            dry scalp treatment,Near me, Hair loss treatment, Hair growth Treatment  Hair loss treatment, Scalp Exfoliation near me`,

        "Nail Care": `  manicure, nail salon, nail salon, nail art , manicure salon ,best nail salon , nail extension, nail spa ,
                            Near menail care, nail art, nail extensions, nail spa, manicure, pedicure, gel nails, acrylic nails, 
                            Near me , pedicure , pedicurist , pedy cure , nail salon , nail salon ,  
                            nail art near me`,


        "Electrical": ` fan repair, regular ceiling fan replacement, regular ceiling fan installation, 
                        regular ceiling fan uninstallation, wall fan installation, exhaust fan installation, pedestal fan installation, tower fan installation, fan regulator replacement,
                        decorative fan installation, smart fan installation, BLDC fan installation, tubelight installation, tubelight repair, ceiling light installation, ceiling light repair, bulb installation, bulb replacement, 
                        fancy light installation, fancy light replacement, hanging light installation, chandelier installation, MCB replacement,
                        fuse replacement, MCB installation, sub meter installation near me`,

        "House cleaning": ` house cleaning services, house cleaning, sofa cleaning, fan cleaning, carpet cleaning, house cleaners, deep cleaning, 
                            furniture cleaning, home cleaners, house deep cleaning, deep cleaners, deep house cleaning, room cleaning services 
                            fridge cleaner,
                            sofa washing services, 
                            full home cleaning, 
                            couch cleaning services, 
                            sofa shampooing,
                            rug cleaning,near me`,

        "Appliance Services": `AC (Split) Service,
                            AC (Window) Service,
                            AC Gas leak fix & refill,
                            Split AC Installation,
                            Split AC Uninstallation,
                            Window AC Installation,
                            Window AC Uninstallation,
                            AC (Split) Check-up,
                            AC (Window) Check-up,
                            Air cooler Standard service ,
                            Air cooler Check-up,
                            Geyser Checkup,
                            Geyser Service,
                            Geyser Installation,
                            Geyser Uninstallation,
                            Inverter Installation,
                            Inverter Uninstallation,
                            Inverter Service,
                            Inverter Fuse Replacement,
                            Stabilizer Installation`,
        "Auto Care": `car repair near me, car service center near me, car service near me,
                            auto service center near me, auto service shops near me, car auto repair,
                            car maintenance shops near me, auto repair near me, automotive repair near me, 
                            vehicle repair near me, auto shop repair near me, auto repair close to me, AC car service near me, 
                            car service, 3M car care, car polish, toyota service center near me, car care, 3M car care near me, car waxing, auto repairing, car care near me`,

        "Cleaning": `housekeeping services, house cleaning services, home cleaning services, professional cleaning services, 
                           deep cleaning services, cleaning services near me, house cleaning near me, sofa cleaning service, couch cleaning service,
                           home cleaners near me, residential cleaning services, home cleaning companies near me, sofa shampoo service, 
                           couch shampoo service, sofa washing services, couch washing service, household cleaning services near me`,

        "Pest Control": `pest control services, pest control near me, exterminator near me, pest exterminator, 
                                cockroach pest control, cockroach exterminator, bed bug treatment, bed bug control, 
                                termite treatment, termite control, anti termite treatment, mosquito control, 
                                rodent control, rat control, insect control services, silverfish control, wasp control,
                                centipede control, cockroach killer, pest removal services near me`,
                                
        "Plumbing": `plumber near me, plumbers near me, plumbing services near me, professional plumbing services,
                            drain cleaning services, drain cleaning near me, water leak detection services, emergency plumber near me,
                            home plumbing services, pipe repair services, CPVC pipe, UPVC pipe, plumbing pipe fittings, 
                            sink pipe repair, P-trap installation, water closet installation, geyser pipe installation near me`,
                            
        "House Help": `house cleaning services, home cleaning services, cleaning services near me, house cleaner near me, 
                                residential cleaning services, professional cleaning services, janitorial services, maid services near me, 
                                house maid services, home cleaners near me, residential cleaners near me, home cleaning companies near me, 
                                household cleaning services near me, housekeeper services, deep cleaning services near me, housekeeping services near me` ,
    };


    // console.log('rendering pro under cat',categoryDescriptions[categoryName])
    const onPressSubCategory = (item,subcatName) => {
        const nearByPros1 = DeepClone(nearByPros)
        setSubCatName(subcatName)
        const filtered = nearByPros1.filter(proArr => {
            return proArr.subcategories.includes(item)
        }
        );
        setFilteredNearByPros(filtered);
        setSubCatPrid(item);

        // console.log('subcat item pressed', item)
    }
    let searchModalDisplay = (
        <Modal isOpen={searchModalOpen} size={'md'} toggle={() => setSearchModalOpen(false)} centered>
            {/* Here I want to render all the searchedPros cards vertically in a modal */}
            <div style={{ padding: 20 }}>
                <div style={{ justifyContent: 'flex-end', display: 'flex', flexDirection: 'row' }}>
                    <div className='crossIcon_ViewPro_Home' style={{ cursor: 'pointer' }}>
                        <img src={CloseIcon} style={{ width: 18, height: 18 }} onClick={() => setSearchModalOpen(false)} />
                    </div>
                </div>
                <div style={{ marginTop: 10 }}>
                    <text className='searchOffer_Text'>Search results for "{serviceSearchedName}"</text>
                </div>
                {/* I want to render serviceSearchPros Array. Please display all the items in serviceSearchPros. Use map and display and call the NewProfessaionalCard component */}
                {serviceSearchPros.length !== 0 ?
                    serviceSearchPros.map((item, index) => {
                        return (
                            <div style={{ marginTop: 10 }} key={index}>
                                <NewProfessionalCard
                                    key={index}
                                    serviceCount={item.SERVICE_COUNT} fromServiceSearch={true} serviceName={item.SERVICE_NAME} servicePriceCurrency={item.MERCHANT_PERSONNEL_TIMEZONE === "Asia/Kolkata" ? '\u20B9' : "$"} proData={item} proArray={item} onPressCard={() => onPressProCard(item)}
                                />
                            </div>
                        )
                    })
                    :
                    <div style={{ marginTop: 20, display: 'flex', justifyContent: 'center' }}>
                        <text style={{ fontSize: 14 }}>No professionals found matching your search</text>
                    </div>
                }
                <hr />
                {/*  */}
            </div>

        </Modal>
    )
    console.log('rendering pro under cat', slugToCatName(searchParams[0])) 
    return (
        <div style={{ backgroundColor: '#fff' }}>                              
            <Helmet>
                <title>SLASH | {categoryName ? categoryName : paramsLocation.state && paramsLocation.state.catItem && paramsLocation.state.catItem.category_name ? paramsLocation.state.catItem.category_name : slugToCatName(searchParams[0])? slugToCatName(searchParams[0]) :''} {subCatName ? `| ${subCatName}` : ''} | {state.address.city}</title>
                <meta name="description" content={categoryDescriptions[categoryName]} />
                 <meta name="keywords" content={categoryDescriptions[categoryName]} />

            </Helmet>
            <Carousel
                activeIndex={activeIndex}
                next={next}
                previous={previous}
                ride="carousel"
                interval={2000}
            >
                {MerchantItems.length > 1 ? <CarouselIndicators className="carousel-indicators_Landing" items={MerchantItems} activeIndex={activeIndex} onClickHandler={() => goToIndex()} /> : null}
                {MerchantSlides}
            </Carousel>
            {
                cityNotYet ?
                    <div style={{ height: 200, display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center'}}>
                        <text style={{textAlign:'center'}}> "We are not yet available in your city. Please check back later."</text>
                    </div>
                    :
            <>
                <div className='subdiv_sv2'>
                    <div style={{ marginTop: 20,marginBottom:20 }} className='proDetail_cont1'>
                    <text className={isMobileView ? 'trustStyle_mobile': 'trustStyle'}>Trusted by {displayCount ? displayCount : '25k' + "+"} happy customers</text>
                    <text style={{marginTop:20}} className={isMobileView ? 'proNamee_style_mobile' : 'proNamee_style'}>{categoryName ? categoryName : paramsLocation.state ? (paramsLocation.state.catItem ? (paramsLocation.state.catItem.category_name).toUpperCase() : '') : ''}</text>
                    <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:20}}>
                    <div className='ratingContainer'>
                        <div className='ratingBadge'>
                            {/* <text className="ratingValue">{proData.MERCHANT_PERSONNEL_RATING ? numeral(proData.MERCHANT_PERSONNEL_RATING).format('0.0') : 4}</Text> */}
                            <text className={isMobileView ? "ratingValue_mobile" : "ratingValue"}>{catRating ? catRating : 4.5}</text>
                            <img src={StarIconGreen} style={{ width: 16, height: 16 }} />
                        </div>
                    </div>
                    {
                    <text className={isMobileView ? 'reviewTextStyle_mobile':'reviewTextStyle'}>{reviewCount + " Reviews"}</text>
                    }
                    </div>
                </div>
                    <div className='catdiv_sv2'>
                        {
                            categories.map(item => {
                                return (
                                    <div onClick={() => onCatSelection(item)} style={{
                                        height: 39, display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', display: 'flex', padding: 12,marginRight:10,
                                        borderRadius: 20,
                                        border: 'solid 1px #747474',
                                        backgroundColor: selectedCatPrid == item.QF_SERVICE_CATEGORY_PRID ? '#8c52ff':'#fff'
                                    }} >
                                        {/* <div className='catmain_sv2' > */}
                                        {/* <img src={item.category_image} className='catImg_sv2' /> */}
                                        {/* </div> */}
                                        <text className='AllServices_sv2' style={{ fontSize:12,fontWeight: selectedCatPrid === item.QF_SERVICE_CATEGORY_PRID ? 600 : 'normal',color:selectedCatPrid == item.QF_SERVICE_CATEGORY_PRID ? '#fff' : '#747474' }} > {item.category_name}</text>
                                    </div>

                                )
                            })
                        }
                    </div>
                    {/* <hr style={{ marginTop: -1, }} /> */}
                    {/* Search Input */}
                    <div className='searchBar_style_sv2'>
                        <SearchBarNew
                            type='text'
                            value={searchTextOffer}
                            placeholder="Search any Service / Professional / Category"
                            onChange={searchBoxOfferhandler}
                            // returnType="done"
                            onClickCross={clearSearchResults}
                            searchTextService={searchTextOffer}
                            onSubmitEditing={clearSearchResults}
                        />
                        {showSearchDropDown ? <Card style={{ position: 'absolute', height: searchDropdownArray.length > 0 ? (searchDropdownArray.length === 1 || searchDropdownArray.length === 2 ? 'auto' : 220) : 150, top: 55, zIndex: 2000, width: '60%', overflow: 'auto' }}>
                            {searchOfferDropDownItem}
                        </Card> : null}
                    </div>
                    {
                        subLoading ?
                            <div style={{ height: 200, display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
                                <ClipLoader widthUnit={"%"} size={40} loadings={subLoading} color="#8c52ff" />
                            </div>
                            :
                            <div className='sub-row-sv2'>
                                {subItems}
                            </div>
                    }
                    {
                        proLoading ?
                            <div style={{ height: 200, display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
                                <ClipLoader widthUnit={"%"} size={40} loadings={proLoading} color="#8c52ff" />
                            </div>
                            :
                           
                            <>
                            {proCards}
                            </>
                    }
                </div>
                {searchModalOpen && searchModalDisplay}
                <>
                    <BookAserviceWithUs />
                </>
            </>
            }
            {/* Filters Modal */}
            <Modal isOpen={filtersModal} toggle={() => setFiltersModal(false)} centered>
                <ModalBody>
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
                        <div className='filters_body_style' onClick={() => setFiltersModal(false)}>
                            <img src={crossIcon} style={{ width: 18, height: 18, }} />
                        </div>
                    </div>
                    <text className='filtersText_sv2_text'>Filters</text>
                    <hr />
                    {/* Date Filter */}
                    <div onClick={() => toggleExpandedDate()} style={header}>
                        <text style={dateStyle}>Date</text>
                        <img src={dateCollapsed ? FilterArrowDown : FilterArrowUp} style={{ width: 13, height: 13 }} />
                    </div>
                    <Collapse isOpen={!dateCollapsed}>
                        <div style={dateViewStyle}>
                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                {/* <TouchableOpacity onPress={() => setIsDateTimePickerVisible(!isDateTimePickerVisible)}> */}
                                <div style={{ flexDirection: 'row', justifyContent: 'flex-start', display: 'flex', alignItems: 'center' }}>
                                    <img src={calendarIcon} style={{ width: 15, height: 15, marginRight: 8 }} />
                                    {/* <text>{fromDateTime ? fromDateTime.format("DD MMM YYYY") : fromDateTime}</text> */}

                                    <DatePicker
                                        value={fromDateTime}
                                        calendarIcon={null}
                                        clearIcon={null}
                                        className='react-date-picker__wrapper'
                                        isOpen={isDateTimePickerVisible}
                                        onChange={handleDatePicked}
                                        minDate={mindate ? new Date(mindate.format("YYYY-MM-DD")) : new Date()}
                                    // onConfirm={handleDatePicked}
                                    // onCancel={cancelPicker}
                                    // onHide={() => {
                                    //     if (isCancel === false) {
                                    //         setIsDateTimePickerVisible1(true)
                                    //     }
                                    // }
                                    // }
                                    />

                                </div>
                                {/* </TouchableOpacity> */}
                                <div style={{ marginTop: 12, width: 15.6, height: 1, backgroundColor: "#a679ff" }}></div>
                                {/* <TouchableOpacity onPress={() => setIsDateTimePickerVisible1(!isDateTimePickerVisible1)}> */}
                                <div style={{ flexDirection: 'row', justifyContent: 'flex-start', display: 'flex', alignItems: 'center' }}>
                                    <img src={calendarIcon} style={{ width: 15, height: 15, marginRight: 8 }} />
                                    {/* <Text>{toDateTime ? toDateTime.format("DD MMM YYYY") : toDateTime}</Text> */}
                                    <DatePicker
                                        value={toDateTime}
                                        date={toDateTime ? new Date(toDateTime.format("YYYY-MM-DD")) : new Date()}
                                        minDate={fromDateTime ? new Date(fromDateTime.format("YYYY-MM-DD")) : new Date()}
                                        // locale="en_US"
                                        calendarIcon={null}
                                        clearIcon={null}
                                        isOpen={isDateTimePickerVisible1}
                                        className='react-date-picker__wrapper'
                                        isVisible={isDateTimePickerVisible1}
                                        onChange={handleDatePicked1}
                                    // onCancel={hideDateTimePicker1}
                                    />
                                </div>
                                {/* </TouchableOpacity>  */}
                            </div>
                        </div>
                    </Collapse>
                    {/* Time Filter */}
                    <div onClick={() => toggleExpandedTime()} style={header}>
                        <text style={dateStyle}>Time</text>
                        <img src={timeCollapsed ? FilterArrowDown : FilterArrowUp} style={{ width: 13, height: 13 }} />
                    </div>
                    <Collapse isOpen={!timeCollapsed} >
                        <div style={timeViewStyle}>
                            <div style={{ flexDirection: 'row', justifyContent: "space-between", display: 'flex', }}>
                                {/* <TouchableOpacity onPress={() => setIsDateTimePickerVisible2(!isDateTimePickerVisible2)}> */}
                                <div style={{ flexDirection: 'row', justifyContent: 'flex-start', display: 'flex', alignItems: 'center' }}>
                                    <img src={timeIcon} style={{ width: 17, height: 17, marginRight: 8 }} />
                                    {/* <text style={{ marginTop: -1 }}>{fromDateTime ? fromDateTime.format("HH:mm") : ""}</text> */}
                                    <TimePicker
                                        format={'HH:mm'}
                                        className='react-time-picker__wrapper'
                                        value={selectedBTimes.fromTime ? new Date(selectedBTimes.fromTime) : null}
                                        onChange={handleDatePicked2}
                                        clockIcon={null}
                                        clearIcon={null}
                                    // isOpen={isDateTimePickerVisible2}
                                    />
                                </div>
                                {/* </TouchableOpacity> */}
                                <div style={{ marginTop: 12, width: 15.6, height: 1, backgroundColor: "#a679ff" }}></div>
                                {/* <TouchableOpacity onPress={() => setIsDateTimePickerVisible3(!isDateTimePickerVisible3)}> */}
                                <div style={{ flexDirection: 'row', justifyContent: 'flex-start', display: 'flex', alignItems: 'center' }}>
                                    <img src={timeIcon} style={{ width: 17, height: 17, marginRight: 8 }} />
                                    {/* <text style={{ marginTop: -1 }}>{toDateTime ? toDateTime.format("HH:mm") : ""}</text> */}
                                    <TimePicker
                                        format={'HH:mm'}
                                        minTime={selectedBTimes.fromTime ? new Date(selectedBTimes.fromTime) : null}
                                        className='react-time-picker__wrapper'
                                        value={selectedBTimes.toTime ? (new Date(selectedBTimes.toTime)) : null}
                                        onChange={handleDatePicked3}
                                        clockIcon={null}
                                        clearIcon={null}
                                    // isOpen={isDateTimePickerVisible3}
                                    />
                                </div>
                                {/* </TouchableOpacity> */}
                            </div>
                        </div>
                    </Collapse>
                    {/* price filter */}
                    <div onClick={() => toggleExpandedPrice()} style={header}>
                        <text style={dateStyle}>Price Range</text>
                        <img src={priceCollapsed ? FilterArrowDown : FilterArrowUp} style={{ width: 13, height: 13 }} />
                    </div>
                    <Collapse isOpen={!priceCollapsed}>
                        <div style={{ marginHorizontal: 30, marginTop: 5 }}>
                            <Range
                                step={100}
                                min={0}
                                max={state.address.country == 'India' ? 15000 : 5000}
                                values={[priceMin, priceMax]}
                                onChange={(values) => onChangeSliderValues(values)}
                                onFinalChange={(values) => onChangeSliderValues(values)}
                                renderTrack={({ props, children }) => (
                                    <div
                                        {...props}
                                        style={{
                                            ...props.style,
                                            height: '2px',
                                            width: '100%',
                                            backgroundColor: '#ccc',
                                            marginTop: '20px',
                                        }}
                                    >
                                        {children}
                                    </div>
                                )}
                                renderThumb={({ props }) => (
                                    <div
                                        {...props}
                                        style={{
                                            ...props.style,
                                            height: '20px',
                                            width: '20px',
                                            borderRadius: '10px',
                                            backgroundColor: '#8c52ff',
                                        }}
                                    />
                                )}
                            />
                        </div>
                        <div style={{ flexDirection: 'row', justifyContent: 'space-between', display: 'flex', marginTop: 20 }}>
                            <div style={priceBox}>
                                <text style={priceTextStyle}>{merchantTimeZone === "Asia/Kolkata" ? '\u20B9' : "$"}{priceMin} </text>
                            </div>
                            <div style={priceBox}>
                                <text style={priceTextStyle}>{merchantTimeZone === "Asia/Kolkata" ? '\u20B9' : "$"}{priceMax} </text>
                            </div>
                        </div>
                    </Collapse>
                    {/* distance filter */}
                    <div onClick={() => toggleExpandedDistance()} style={header}>
                        <text style={dateStyle}>Distance</text>
                        <img src={distanceCollapsed ? FilterArrowDown : FilterArrowUp} style={{ width: 13, height: 13 }} />
                    </div>
                    <Collapse isOpen={!distanceCollapsed}>
                        <div style={{ marginHorizontal: 30, marginTop: 5 }}>
                            {/* <MultiSlider
                                    values={[distanceMin, distanceMax]}
                                    min={0}
                                    max={100}
                                    selectedStyle={{ backgroundColor: 'rgb(140,82,255)' }}
                                    unselectedStyle={{ backgroundColor: '#e1e1e1' }}
                                    pressedMarkerStyle={{ backgroundColor: '#563951' }}
                                    markerStyle={{ height: 15, width: 15, borderRadius: 10, backgroundColor: 'rgb(140,82,255)', borderWidth: 0.2, borderColor: 'rgb(140,82,255)' }}
                                    onValuesChange={(values) => onChangeDistanceSliderValues(values)}
                                    onValuesChangeFinish={(values) => onChangeDistanceSliderValues(values)}
                                    sliderLength={deviceWidth - 60}
                                    step={1}
                                /> */}
                            <Range
                                step={1}
                                values={[distanceMin, distanceMax]}
                                min={0}
                                max={state.address.country == 'India' ? 20 : 25}
                                onChange={(values) => onChangeDistanceSliderValues(values)}
                                onFinalChange={(values) => onChangeDistanceSliderValues(values)}
                                renderTrack={({ props, children }) => (
                                    <div
                                        {...props}
                                        style={{
                                            ...props.style,
                                            height: '2px',
                                            width: '100%',
                                            backgroundColor: '#ccc',
                                            marginTop: '20px',
                                        }}
                                    >
                                        {children}
                                    </div>
                                )}
                                renderThumb={({ props }) => (
                                    <div
                                        {...props}
                                        style={{
                                            ...props.style,
                                            height: '20px',
                                            width: '20px',
                                            borderRadius: '10px',
                                            backgroundColor: '#8c52ff',
                                        }}
                                    />
                                )}
                            />
                        </div>
                        <div style={{ flexDirection: 'row', justifyContent: 'space-between', display: 'flex', marginTop: 20 }}>
                            <div style={priceBox}>
                                <text style={priceTextStyle}>{distanceMin}{merchantTimeZone === "Asia/Kolkata" ? " km" : " mi"}</text>
                            </div>
                            <div style={priceBox}>
                                <text style={priceTextStyle}>{distanceMax}{merchantTimeZone === "Asia/Kolkata" ? " km" : " mi"} </text>
                            </div>
                        </div>
                    </Collapse>
                    {/* apply and reset UI */}
                    <div style={{ flexDirection: 'row', justifyContent: 'space-between', display: 'flex', marginTop: 20 }}>
                        <div onClick={() => onPressReset(true)} style={resetStyle}>
                            <text style={ResetTextStyle}>Reset</text>
                        </div>
                        {
                            applyButtonLoading
                                ?
                                <div style={{ display: 'flex', width: '47%', height: 60, flexDirection: 'row', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
                                    <ClipLoader widthUnit={"%"} size={25} loadings={applyButtonLoading} color="#2C2165" />
                                </div>
                                :
                                <div style={updateStyle} onClick={() => onApplyFilters(true, false)}  >
                                    <text style={updateTextStyle}>Update</text>
                                </div>
                        }
                    </div>
                </ModalBody>
            </Modal>

        </div>


    )
}
